import { Stethoscope, Sun, Home, Baby, HeartHandshake, Sparkles, Flower2, Smile } from "lucide-react";

export const ICONS = {
  stethoscope: Stethoscope,
  sun: Sun,
  home: Home,
  baby: Baby,
  heart: HeartHandshake,
  sparkles: Sparkles,
  flower: Flower2,
  smile: Smile,
};

export const ServiceIcon = ({ name, className = "h-5 w-5" }) => {
  const Icon = ICONS[name] || Sparkles;
  return <Icon className={className} aria-hidden="true" />;
};
